module.exports = __webpack_public_path__ + "img/zhibo.979bd61a.png";